export const F360PageTitles = {
  Store: "F360 - Store",
  Dashboard: "F360 - Dashboard",
  RegraDeRateio: "F360 - Regras de rateio",
  CentrosDeCusto: "F360 - Centros de custo",
  PlanoDeContas: "F360 - Plano de contas",
  ClientesFornecedores: "F360 - Clientes e fornecedores",
  Relatorios: "F360 - Relatórios",
  Usuarios: "F360 - Usuários",
  Integracoes: "F360 - Integrações",
  InsightsIA: "F360 - Insights IA",
  InsightsIADRE: "F360 - Insights IA - DRE",
  InsightsIAFluxoDeCaixa: "F360 - Insights IA - Fluxo de caixa",
  Credenciamento: "F360 - Credenciamento",
  Treinamentos: "F360 - Treinamentos",
  SolicitacaoCredenciamento: "F360 - Solicitação de credenciamento",
  GestaoContratos: "F360 - Gestão de contratos",
  Gestor360: "F360 - Gestor 360",
  MinhaGestao: "F360 - Cadastros",
  Empresas: "F360 - Empresas",
  Contas: "F360 - Contas",
  Adquirentes: "F360 - Adquirentes",
  Certificados: "F360 - Certificados",
  VisaoGeral: "F360 - Visão geral",
  VisaoEstrategica: "F360 - Visão estratégica",
  AutoContratacao: "F360 - Auto contratação",
  PortalComunicacao: "F360 - Portal de comunicação",
  DiagnosticoEmpresas: "F360 - Diagnóstico - Empresas",
  DiagnosticoDetalhes: "F360 - Diagnóstico - Detalhes",
  Antecipa: "F360 - Antecipa",
  AntecipaMinhasEmpresas: "F360 - Antecipa - Minhas empresas",
  AntecipaAntecipacao: "F360 - Antecipa - Antecipação",
  AntecipaMinhasOperacoes: "F360 - Antecipa - Minhas operações",
  AntecipaCredito: "F360 - Antecipa - Crédito",
  AntecipaAcesso: "F360 - Antecipa - Acesso",
  Notificacoes: "F360 - Notificações",
  ConfiguracoesVAN: "F360 - Configurações de VAN",
  ContratosGerenciamento: "F360 - Contratos - Gerenciamento",
  ContratosHistoricoAceites: "F360 - Contratos - Histórico de aceites",
  Cupons: "F360 - Cupons"
} as const;
